import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import classes from "./partlist.module.scss";
import { API_HOST } from "src/utils/constants";
import { useSortable } from "@dnd-kit/sortable";
import { PartWithThumbnail } from "../domain/CourseEditModel";
import { CSS } from "@dnd-kit/utilities";
import { useAtom } from "jotai";
import { isAnyPartDraggingAtom } from "./EditThemeParts";
import { useI18n } from "src/utils/lni18n";
import CardLink from "src/components/CardLink/CardLink";

export interface PartProps {
    part: PartWithThumbnail;
    dragged?: boolean;
    onContextMenu: React.MouseEventHandler<HTMLElement>;
    dummy?: boolean;
    /** Where the part opens - the name becomes a link to it. */
    to?: string;
}


export const PartSmall: React.FC<PartProps> = ({ part, dragged, onContextMenu, dummy, to }) => {


    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: part.Id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: dragged ? "75%" : ""
    };

    // The whole card is still what the mouse drags, but the keyboard reaches it through
    // the name link: dnd-kit's role="button" and tabIndex on the card would put a link
    // inside a button and add a second tab stop, so only its pointer handling stays on
    // the card, and the key handling and the drag instructions go to the link.
    const { onKeyDown, ...pointerListeners } = listeners ?? {};
    const linkKeyDown = onKeyDown as React.KeyboardEventHandler<HTMLAnchorElement> | undefined;


    /**
     *  if this is true - there's a drag doing on somewhere. Just switch of all Tooltips.
     */
    const [aPartIsDragging] = useAtom(isAnyPartDraggingAtom);
    const { languageService: t } = useI18n();


    /**
     * A marker just to show where a drop would be fitted 
     */
    if (part.Id === "mark") return <div className={`${classes.marker}`} ></div>

     /**
      * dummy === true means this is just a placeholder when the theme is empty of parts.
      * show this "part" as a target to drag new parts into the theme.
      */
    if (dummy) {
        return <div ref={setNodeRef} className={`${classes.dummy}`} id="dummy"  ><div>{t.getText("empty")}</div></div>
    }


    return (

        <div  style={style} ref={setNodeRef} id={"l_" + part.Id} className={`hand m-3 ${classes.partListing} ${classes.smallPart} ${dragged && classes.dragged}`} {...pointerListeners} >
            <div onContextMenu={onContextMenu} className={`card-box card ${classes['part-listing-card']}`} >

                <div className={"text-center " + classes['card-image']}>
                    {part.ImageUrl ?
                        <img draggable={false} src={API_HOST + part.ImageUrl} alt={part.Name} />
                        : <div className={classes.imageDummy + " w-100 h-100"}>&nbsp;</div>
                    }

                </div>
                <div className="overflow-hidden p-2">
                    {to
                        ? <CardLink to={to} onKeyDown={linkKeyDown} aria-describedby={attributes["aria-describedby"]}>{part.Name}</CardLink>
                        : part.Name}
                </div>
            </div>

            {/* hide tooltip if there is a drag operation going on */}
            {!aPartIsDragging &&
                <UncontrolledTooltip placement="auto-start" autohide={false} target={'l_' + part.Id} trigger={'hover'}
                    delay={{ show: 300, hide: 0 }}>
                    <strong>{part.Name}</strong>
                </UncontrolledTooltip>
            }
        </div>
    );

};